import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {toSignal} from "@angular/core/rxjs-interop";
import {Observable, ReplaySubject} from 'rxjs';
import {map} from 'rxjs/operators';

export enum SortBy {
    Created,
    Modified,
}

export enum ColorSwatchKey {
    Black,
    White,
    Grey,
    DarkGrey,
    Checked,
}

export class SlackChannel {
    id: string;
    name: string;
    is_private: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class PreferencesService {
    private _preferences: any;
    private _immediatePrefsSubject = new ReplaySubject<any>();

    public preferences: ReplaySubject<any>;
    public immediatePrefsSignal = toSignal(this._immediatePrefsSubject.asObservable(), {initialValue: {}});

    constructor(private http: HttpClient) {
        this._preferences = {};
        this.preferences = new ReplaySubject<any>(1);
        this.getPreferences();
    }

    public getPreferences(): void {
        this.http.get('/api/auth/pref/').subscribe((result: any) => {
            this._preferences = result.data;
            this._preferences.slack = result.slack;
            this.preferences.next(this._preferences);
            this._immediatePrefsSubject.next(this._preferences);
        });
    }

    public setPreferences(preferences: any): void {
        this._immediatePrefsSubject.next(preferences);
        const data = {
            prefs: preferences,
        };
        this.http.post('/api/auth/pref/', data).subscribe((result: any) => {
            this._preferences = result.data;
            this._preferences.slack = result.slack;
            this.preferences.next(this._preferences);
            this._immediatePrefsSubject.next(this._preferences);
        });
    }

    public sparseUpdate(key: string, value: string|number) {
        this._preferences[key] = value;
        // Send a clone so the signal will emit properly
        this._immediatePrefsSubject.next(structuredClone(this._preferences));

        const data = {};
        data[key] = value;
        this.http.patch('/api/auth/pref/0/', data).subscribe((result: any) => {
            this._preferences = result.data;
            this._preferences.slack = result.slack;
            this.preferences.next(this._preferences);
        });
    }

    public getSlackChannels(): Observable<SlackChannel[]> {
        return this.http.get('/api/slack/channels').pipe(map((data: any) => data.channels));
    }

    testSlack(channel: string): Observable<any> {
        const url = '/api/slack/test';
        return this.http.post(url, { channel: channel });
    }

    uninstallSlack(): Observable<any> {
        const url = '/api/slack/uninstall';
        return this.http.post(url, {});
    }
}
